import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.15);
    opacity: 0.7;
  }
`;

const PulsatingDiv = styled.div`
position: fixed;
  right: 50px;
  bottom: 50%;
  top: 50%;
  z-index: 9999;

  width: 32px;
  animation: ${pulse} 1.2s ease-in-out infinite;
  transform-origin: center;

  @media (min-width: 768px) {
    display: none;
  }
`;

export default function Chevron() {
    return (
        <PulsatingDiv
            data-rid="9509737c-12fa-492f-bcf4-31b6ff9d8d81"
            className="r-1qb9b9a"
        >
            <span style={{ display: "contents" }}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{
                        fill: "none",
                        stroke: "#763099",
                        width: "80px",
                        height: "auto",
                    }}
                    role="presentation"
                >
                    <polyline points="13 17 18 12 13 7" />
                    <polyline points="6 17 11 12 6 7" />
                </svg>
            </span>
        </PulsatingDiv>
    );
}